import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { RecentDocumentsSearchResults } from './sub-models/recent-documents-search-results.model';

export const RECENT_DOCUMENTS_SEARCH_SCHEMA = Object.freeze({
  INVOICES: RecentDocumentsSearchResults,
  ESTIMATES: RecentDocumentsSearchResults,
  CREDIT_MEMOS: RecentDocumentsSearchResults,
  PURCHASE_ORDERS: RecentDocumentsSearchResults,
});
const RECORD = generateSchema(RECENT_DOCUMENTS_SEARCH_SCHEMA);
const KEYS: any = generateKeys(RECENT_DOCUMENTS_SEARCH_SCHEMA);

export class RecentDocumentsSearch extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.INVOICES,
        value: new RecentDocumentsSearchResults(this.invoices),
      },
      {
        key: KEYS.ESTIMATES,
        value: new RecentDocumentsSearchResults(this.estimates),
      },
      {
        key: KEYS.CREDIT_MEMOS,
        value: new RecentDocumentsSearchResults(this.creditMemos),
      },
      {
        key: KEYS.PURCHASE_ORDERS,
        value: new RecentDocumentsSearchResults(this.purchaseOrders),
      },
    ]) as RecentDocumentsSearch;
  }

  get invoices(): RecentDocumentsSearchResults {
    return this.get(KEYS.INVOICES);
  }

  get estimates(): RecentDocumentsSearchResults {
    return this.get(KEYS.ESTIMATES);
  }

  get creditMemos(): RecentDocumentsSearchResults {
    return this.get(KEYS.CREDIT_MEMOS);
  }

  get purchaseOrders(): RecentDocumentsSearchResults {
    return this.get(KEYS.PURCHASE_ORDERS);
  }

  totalNumberOfResults(): number {
    return (
      this.invoices.totalMatches +
      this.estimates.totalMatches +
      this.creditMemos.totalMatches +
      this.purchaseOrders.totalMatches
    );
  }
}
